// ONE button cluster for every document surface (owner 2026-10-12). NOT issued: [Preview] (draft PDF in the document modal) + [Issue & print] (the single primary;
// issues, then opens the window). ISSUED: a single [Open PDF] (the single primary on a record sheet). Everything opens the document modal (openDocModal).
//   fetchPdf(issuedResult) -> Blob   fetchHtml?(issuedResult) -> html (printable fallback)   onIssue? -> async, falsy = failed (already surfaced by the caller)
// noPreview = nothing stored to preview yet (a proforma not yet saved: there is no stateless proforma endpoint). No onIssue = a draft that is issued elsewhere: Preview only. `primary={false}` keeps Open PDF bordered.
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IcoLn } from '../../shell/ActionIcons';
import useActionLabel from '../../i18n/useActionLabel';
import api from '../../services/api';
import { openDocModal } from './openDocModal';

// a stored invoice / proforma (draft = PREVIEW-stamped): the server PDF, with the printable HTML as the fallback
export const invoicePdfSource = (id, lang) => { const l = lang && String(lang).startsWith('fr') ? 'fr' : 'en'; return { fetchPdf: () => api.getInvoicePdf(id, l), fetchHtml: () => api.getInvoiceHtml(id, l).then((d) => d.html) }; };

export function useOpenPdf({ fetchPdf, fetchHtml, title, printLog, sheet }) {
  const { t } = useTranslation('common');
  const [busy, setBusy] = useState(false); const [err, setErr] = useState('');
  const open = (prepare) => {   // call straight from the click handler
    if (busy) return;
    setBusy(true); setErr('');
    openDocModal({ fetchPdf, fetchHtml, prepare, title, printLog, sheet }).catch((e) => e && e.message && setErr(t('requestFailed'))).finally(() => setBusy(false));
  };
  return { open, busy, err };
}

export default function DocPdfActions({ issued, fetchPdf, fetchHtml, onIssue, issueDisabled = false, issueTitle, previewDisabled = false, noPreview = false, primary = true, title, printLog, sheet }) {
  const al = useActionLabel(); const { t } = useTranslation('common');
  const { open, busy, err } = useOpenPdf({ fetchPdf, fetchHtml, title, printLog: issued ? printLog : undefined, sheet });
  return (<>
    {err && <span className="ferr" role="alert" data-testid="doc-pdf-error">{err}</span>}
    {issued
      ? <button type="button" className={primary ? 'btn success' : 'btn'} disabled={busy} title={busy ? t('pdfBusy') : undefined} onClick={() => open()} data-testid="doc-open-pdf"><IcoLn name="invoice" />{al('openPdf')}</button>
      : <>
        {!noPreview && <button type="button" className="btn" disabled={busy || previewDisabled} title={busy ? t('pdfBusy') : undefined} onClick={() => open()} data-testid="doc-preview-pdf"><IcoLn name="view" />{al('previewPdf')}</button>}
        {onIssue && <button type="button" className="btn success" disabled={busy || issueDisabled} title={issueTitle || (busy ? t('pdfBusy') : undefined)} onClick={() => open(onIssue)} data-testid="doc-issue-print"><IcoLn name="print" />{al('issueAndPrint')}</button>}
      </>}
  </>);
}

// Open PDF icon of a stored invoice / proforma / draft (registers, order document tabs)
export function InvoicePdfIconButton({ id, kind, ...rest }) {   // kind (invoice|proforma) engages the Print log; omitted when the row does not know it
  const { i18n } = useTranslation();
  return <DocPdfIconButton {...invoicePdfSource(id, i18n.language)} printLog={kind ? { kind, id } : undefined} {...rest} />;
}

// row / table icon: Open PDF of an issued document (greyed with the reason when `disabledReason`)
export function DocPdfIconButton({ fetchPdf, fetchHtml, disabledReason = '', title, testId = 'row-open-pdf', printLog, sheet }) {
  const al = useActionLabel();
  const { open, busy } = useOpenPdf({ fetchPdf, fetchHtml, title, printLog, sheet });
  const l = al('openPdf');
  return <button type="button" className="tbl-ico-btn" disabled={!!disabledReason || busy} title={disabledReason ? `${l} — ${disabledReason}` : l} aria-label={l} onClick={() => open()} data-testid={testId}><IcoLn name="invoice" /></button>;
}
